export const ID = 'ERROR';

export const THROW_FAILED = `${ID}/THROW_FAILED`;
